export default __webpack_public_path__ + "static/test_3_2-f5ebb253d583353d4b24caabd5c95b64.png";